__turbopack_context__.v({
  "facade": "me2F5a_facade",
  "iframe": "me2F5a_iframe",
  "playButton": "me2F5a_playButton",
  "player": "me2F5a_player",
  "thumbnail": "me2F5a_thumbnail",
});
